/**
 * ハイスコア・きょうのベストに添える「コンティニュー・おはしを使ったか」の印。
 *
 * ランキングには、コンティニューもおはしも使わなかったプレイだけを送っている。
 * 一方ハイスコア・きょうのベストは使ったプレイも含むので、そのままだとランキングの数字と食い違う。
 * 使ったプレイの記録には小さく印を付け、今日の県の行ではランキングに出る方の点も並べて見せる。
 */

/** 使ったプレイの記録に添える文言。 */
export const ASSISTED_MARK = '（おはし・コンティニューあり）';

function formatScore(score: number): string {
  return Math.max(0, Math.floor(score)).toLocaleString('ja-JP');
}

/** ハイスコアの数字のうしろに付ける小さな印（使っていなければ空）。 */
export function highScoreMarkHtml(record: { highScoreAssisted: boolean }): string {
  return record.highScoreAssisted ? `<small class="result-assisted">${ASSISTED_MARK}</small>` : '';
}

/**
 * 今日の県の行の「きょうのベスト …」の部分。
 * いちばんの記録が使ったプレイなら印を付け、ランキングに出る方（使っていないベスト）も並べる。
 */
export function dailyBestHtml(view: {
  bestToday: number;
  bestTodayAssisted: boolean;
  bestTodayNoAssist: number;
}): string {
  const best = `きょうのベスト <b>${formatScore(view.bestToday)}</b>`;
  if (!view.bestTodayAssisted) return best;
  const ranked =
    view.bestTodayNoAssist > 0
      ? `ランキングは <b>${formatScore(view.bestTodayNoAssist)}</b>`
      : 'ランキングにはまだ入っていません';
  return `${best}<small class="result-assisted">${ASSISTED_MARK}・${ranked}</small>`;
}
